var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 46,
    viewBox: "0 0 182 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5L22.6 5.00001L22.6 17.6L5.5 5Z",
    fill: "url(#paint0_linear_1_6757)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5012 15.0016L41.0136 15.0016L41.0136 10.3648L47.5012 15.0016Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9801 16.3252L41.0132 10.3649L41.0132 23.2391L33.9801 16.3252Z",
    fill: "url(#paint1_linear_1_6757)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0148 23.2377L22.6569 41L22.6569 5L41.0148 23.2377Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.84 24.36L69.6 30H67.2L64.28 24.24C64.06 23.82 63.74 23.56 63.26 23.56C62.74 23.56 61.9 23.94 61.1 24.64V30H58.7V15.96H64.84C67.7 15.96 68.98 17.64 68.98 19.44C68.98 21.1 67.9 22.96 65.64 23.36C66.24 23.56 66.58 23.84 66.84 24.36ZM64.26 23.08C65.8 23.14 66.78 21.56 66.78 19.78C66.78 17.9 65.66 16.26 63.4 16.26H61.1V24.34C62 23.62 63.12 23.04 64.26 23.08ZM74.1859 22.24V29.7C77.9659 29.7 80.2259 29.46 82.5259 28.4V30H71.7859V15.96H82.2259V17.56C80.2259 16.6 78.0059 16.26 74.1859 16.26V21.94H81.1259V22.24H74.1859ZM94.677 15.96H96.277L91.457 30H89.057L84.237 15.96H86.637L91.317 29.56L93.797 22.32C94.617 19.94 94.877 17.9 94.677 15.96ZM100.573 22.24V29.7C104.353 29.7 106.613 29.46 108.913 28.4V30H98.1727V15.96H108.613V17.56C106.613 16.6 104.393 16.26 100.573 16.26V21.94H107.513V22.24H100.573ZM118.774 24.36L121.534 30H119.134L116.214 24.24C115.994 23.82 115.674 23.56 115.194 23.56C114.674 23.56 113.834 23.94 113.034 24.64V30H110.634V15.96H116.774C119.634 15.96 120.914 17.64 120.914 19.44C120.914 21.1 119.834 22.96 117.574 23.36C118.174 23.56 118.514 23.84 118.774 24.36ZM116.194 23.08C117.734 23.14 118.714 21.56 118.714 19.78C118.714 17.9 117.594 16.26 115.334 16.26H113.034V24.34C113.934 23.62 115.054 23.04 116.194 23.08ZM126.12 30H123.72V15.96H126.12V30ZM131.217 22.24V29.7C134.997 29.7 137.257 29.46 139.557 28.4V30H128.817V15.96H139.257V17.56C137.257 16.6 135.037 16.26 131.217 16.26V21.94H138.157V22.24H131.217ZM145.924 30.3C144.424 30.3 142.804 30.02 141.184 29.5L142.064 25.9C143.764 28.62 145.684 29.66 147.124 29.66C148.724 29.66 149.744 28.7 149.744 27.34C149.744 26.04 148.784 24.34 146.364 22.82L149.204 18.94H141.884V15.96H151.664V16.32L148.424 20.62C151.344 21.58 152.564 23.38 152.564 25.16C152.564 28.52 149.724 30.3 145.924 30.3ZM159.726 30H153.966V15.96H159.806C164.126 15.96 166.706 18.14 166.706 22.72C166.706 27.92 163.066 30 159.726 30ZM157.566 16.38V29.58H158.446C161.106 29.58 163.106 28.24 163.106 22.72C163.106 17.86 161.206 16.36 158.986 16.38H157.566Z",
    fill: "#333333"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_6757",
    x1: 6.4,
    y1: 6.36481,
    x2: 28,
    y2: 6.36482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80DBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#194BA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_6757",
    x1: 41.0183,
    y1: 16.7714,
    x2: 33.9558,
    y2: 16.7714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80DAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A4CA7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.86c9c0c29a1f9bd3d30f3d4e69786615.svg";
export { ForwardRef as ReactComponent };